import type { Quote } from "./components/types";
import compact from "lodash/compact";
import keyBy from "lodash/keyBy";
import omit from "lodash/omit";
import sample from "lodash/sample";
import uniq from "lodash/uniq";
import values from "lodash/values";
import { quotesWithId } from "./quotes";

const LOCAL_STORAGE_KEY = "__solved_quotes_by_id__"; // Updated key

const quotes = keyBy(
  quotesWithId,
  (quote) => quote.id
);

const getSolvedIds = (): string[] => {
  const solvedStr = localStorage.getItem(LOCAL_STORAGE_KEY);
  return solvedStr ? uniq(JSON.parse(solvedStr)) : [];
};

export const markQuoteAsSolved = ({ id }: { id: string }) => {
  const solvedIds = getSolvedIds();
  solvedIds.push(id);
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(solvedIds));
};


export const getUnsolvedQuote = (): Quote | undefined =>
  sample(values(omit(quotes, getSolvedIds())));

export const getSolvedQuotes = (): Quote[] =>
  compact(getSolvedIds().reverse().map((id) => quotes[id])) as Quote[]; // Type casting to Quote[]